import { Dayjs } from "dayjs";

export const getStatusFromEnum = (status: number) => {
  switch (status) {
    case 0:
      return "Nowe";
    case 1:
      return "Do ostatecznej akceptacji";
    case 2:
      return "Wstępna akceptacja";
    case 3:
      return "Rezygnacja";
    case 4:
      return "Zaaakceptowane";
    case 5:
      return "Anulowane";
    case 6:
      return "W trakcie realizacji";
    case 7:
      return "Zrealizowane";
    case 8:
      return "Weryfikacja klienta";
  }
};

export const getPurposeFromEnum = (purpose: number) => {
  switch (purpose) {
    case 0:
      return "Składowanie";
    case 1:
      return "Cross-docking";
    case 2:
      return "Fullfilment";
  }
};

export const getTypeFromEnum = (type: number) => {
  switch (type) {
    case 0:
      return "Neutralne";
    case 1:
      return "Medyczne";
    case 2:
      return "Art. spożywcze";
    case 3:
      return "Duże ADR";
    case 4:
      return "Inne";
  }
};
export const getPlaceEnum = (type: number) => {
  switch (type) {
    case 0:
      return "Wewnątrz";
    case 1:
      return "Na zewnątrz";
  }
};
export const getTemperatureConditionsEnum = (type: number) => {
  switch (type) {
    case 0:
      return "Nieogrzewane";
    case 1:
      return "Chłodnia";
    case 2:
      return "Ogrzewane";
    case 3:
      return "Kontrola temperatury";
  }
};
export const getStatusOfOfferEnum = (type: number) => {
  switch (type) {
    case 0:
      return "Nowa";
    case 1:
      return "Konsultowana";
    case 2:
      return "Zaakceptowana";
    case 3:
      return "Rezygnacja";
    case 4:
      return "Anulowana";
    case 5:
      return "W trakcie wyceny";
    case 6:
      return "Gotowa";
    case 7:
      return "Brak";
    case 8:
      return "Wycofana";
    case 9:
      return "Zatwierdzona";
  }
};
export const getUnitFromEnum = (status: number) => {
  switch (status) {
    case 0:
      return "Paletodoba";
    case 1:
      return "Paleta";
    case 2:
      return "Paleta mix";
    case 3:
      return "Etykieta lub karton";
    case 4:
      return "Sztuka lub karton";
    case 5:
      return "m2";
    case 6:
      return "m3";
  }
};

export const getServiceFromEnum = (purpose: number) => {
  switch (purpose) {
    case 0:
      return "Składowanie";
    case 1:
      return "Crossdocking";
    case 2:
      return "Fullfilment";
    case 3:
      return "Etykietowanie";
    case 4:
      return "Pakowanie";
    case 5:
      return "Sortowanie";
    case 6:
      return "E-commerce";
    case 7:
      return "Wysyłka";
    case 8:
      return "Inne";
    case 9:
      return "Przyjęcie Towaru";
    case 10:
      return "Wydanie Towaru";
  }
};

export const getMagazineTypeFromEnum = (type: number) => {
  switch (type) {
    case 0:
      return "Magazyn dedykowany";
    case 1:
      return "Multimagazyn";
  }
};
export const getTypeOfPackage = (type: number) => {
  switch (type) {
    case 0:
      return "Karton";
    case 1:
      return "BigBag";
    case 2:
      return "Paleta EUR";
    case 3:
      return "Paleta EUR 1/2";
    case 4:
      return "Inna paleta";
    case 5:
      return "Inne";
  }
};
export function priceFormating(price: number) {
  var x = price.toFixed(2);
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return `${parts.join(".")} zł`;
}

export const dateFormating = (date: Date|Dayjs) => {
  const dateSeconds = Date.parse(date?.toString());
  const dateObject = new Date(dateSeconds);
  return dateObject.toLocaleDateString("pl-PL");
};
